export default __webpack_public_path__ + "static/media/slide-2-mobile.a84af643.png";